import React from "react"
import PropTypes from "prop-types"

import styled, { css } from "styled-components"

const ALLOWED_SCREENS = ["phone", "phablet", "tablet", "desktop", "lgscreen"]

const ShowStyles = styled.div`
  ${({ theme, $from }) =>
    $from &&
    css`
      display: none;

      ${theme.media[$from]`
        display: block;
      `}
    `}
  ${({ theme, $until }) =>
    $until &&
    css`
      display: block;

      ${theme.media[$until]`
        display: none;
      `}
    `}
`

export function MfShow({ children, from = "phone", until = undefined }) {
  return (
    <ShowStyles $from={from} $until={until}>
      {children}
    </ShowStyles>
  )
}

MfShow.propTypes = {
  children: PropTypes.node.isRequired,
  from: PropTypes.oneOf(ALLOWED_SCREENS),
  until: PropTypes.oneOf([...ALLOWED_SCREENS, undefined]),
}
